/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_End_Round_ReadyInputs */



/**
* | output |
* | --- |
* | "End this round" |
*
* @param {Rounds_End_Round_ReadyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_end_round_ready = /** @type {((inputs?: Rounds_End_Round_ReadyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_End_Round_ReadyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Terminer cette ronde")
	if (locale === "es") return /** @type {LocalizedString} */ ("Finalizar esta ronda")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Encerrar esta rodada")
	if (locale === "it") return /** @type {LocalizedString} */ ("Termina questo round")
	return /** @type {LocalizedString} */ ("End this round")
});